/**
 * SCIM tokens management page — URL search-param schema.
 *
 * Per CLAUDE.md "URL is the source of truth for list/filter
 * state": the focus param drives row highlighting after the
 * operator clicks a token chip on the operations page. No
 * useState mirror; the page reads via `useSearch`.
 *
 * Filters today:
 *
 *   focus  — UUID of the token to scroll-highlight on mount.
 *            Optional. The page tolerates a stale id (token
 *            was already revoked / cascaded away) by simply
 *            not finding a row — no error UX, just no-op.
 */

import { z } from "zod";

export const scimTokensSearchSchema = z.object({
  // .catch(undefined) so a malformed or stale focus value (the
  // referenced token has already been cascaded away, or somebody
  // shared a link with garbage in it) degrades to "no
  // highlight" instead of throwing the whole page into an error
  // boundary. UUID validation is still applied — anything that
  // doesn't parse becomes undefined.
  focus: z.string().uuid().optional().catch(undefined),
});
export type ScimTokensSearch = z.infer<typeof scimTokensSearchSchema>;
